import { render, staticRenderFns } from "./button-options.vue?vue&type=template&id=5f280acf&scoped=true"
import script from "./button-options.vue?vue&type=script&lang=js"
export * from "./button-options.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f280acf",
  null
  
)

export default component.exports